import { selectLanguages } from '@modules/admin/Admin.Dux'
import React from 'react'
import { withTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import { compose } from 'redux'
import './MultiSelect.scss'
import SelectField from './SelectField'

class SelectLanguageField extends React.Component {
  static defaultProps = {
    languages: [],
    valueKey: 'iso_code',
  }

  render() {
    const { languages, placeholder, multi, t } = this.props
    return (
      <SelectField
        {...this.props}
        placeholder={placeholder || `${multi ? t('Idiomas') : t('Idioma')}`}
        options={languages}
      />
    )
  }
}

const mapStateToProps = (state) => ({
  languages: selectLanguages(state),
})
export default compose(withTranslation(), connect(mapStateToProps))(SelectLanguageField)
